
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

const CallForDestructionForm = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer"
          onClick={() => navigate("/engage")}
        />
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-black mb-8 text-center">
        iSPAI Call for Destruction (CfD)
      </h1>

      <div className="w-full max-w-4xl">
        {/* Purpose Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">Purpose</h2>
            <p className="text-gray-700 leading-relaxed">
              The Call for Destruction (CfD) process allows community members to request the removal of content that is 
              out-of-date, plagiarized, misrepresented, invalid, or protected by intellectual property rights. This form 
              enables you to formally request content removal while providing necessary evidence and justification for the 
              destruction request.
            </p>
          </CardContent>
        </Card>

        {/* Instructions Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">Instructions</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold">1. Identify Content Issue Type</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Select the specific reason why the content should be removed (e.g., Intellectual Property Violation, 
                  Factual Inaccuracy, Security Risk, etc.).
                </p>
              </div>

              <div>
                <h3 className="font-semibold">2. Determine Bounty Structure</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Decide whether to offer token rewards for successful content identification and removal.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">3. Assign Creator</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Select a creator who will oversee the destruction process and validate removal requests.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">4. Provide Detailed Information</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  Submit comprehensive details including content location, evidence supporting removal, and clear 
                  justification for the destruction request.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Next Button */}
        <div className="flex justify-center mt-8">
          <Button 
            className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded"
            onClick={() => navigate("/call-for-destruction/functional-area")}
          >
            Next: Identify Content Issue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CallForDestructionForm;
